
const BASE_URL = process.env.REACT_APP_BASE_URL;
  const token = window.sessionStorage.getItem("jwtToken");

export const excludeLiveTrades = async (stockName, businessDate) => {
    try {
      const response = await fetch(`${BASE_URL}/excludeLiveTrades`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
           Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
          stockName,
          businessDate,
        }),
      });
  
      if (!response.ok) {
        throw new Error('Failed to persist data');
      }
  
      return await response.json();
    } catch (error) {
      console.error('Error persisting data:', error);
      throw error;
    }
  };

  export const fetchAllExcludedLiveTrades = async () => {
      try {
        const response = await fetch(`${BASE_URL}/getExcludedLiveTrades`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
          }
        });
        if (!response.ok) {
          throw new Error('Failed to fetch Excluded Live Trades');
        }
    
        return await response.json();
      } catch (error) {
        console.error('Error fetching Excluded Live Trades:', error);
        throw error;
      }
    };
  